import type { CoreFetch } from '~/types/CoreFetch'

export function provideFetchChartTags(coreFetch: CoreFetch) {
  /**
   * Fetches all possible charts tags
   *
   * @returns A promise that resolves to the tags
   */
  return function (country?: string) {
    return coreFetch.$get<{ genres: string[]; countries: string[] }>(
      '/track/chart/tags/',
      {
        params: {
          country,
        },
      },
    )
  }
}
